import type {YomiriExtension,YomiriManga,YomiriChapter,YomiriPage} from '../../types/extension.ts';
import type {YomiriHttpClient} from '../../network/types.ts';
export abstract class MaintainedSource implements YomiriExtension {
    abstract readonly id: string;
    abstract readonly name: string;
    abstract readonly website: string;
    readonly lang = 'es';
    readonly version = '1.0.0';
    constructor(protected readonly http: YomiriHttpClient) { }
    get iconUrl() { return `/source-icons/${this.id}.png`; }
    protected async text(url: string, form?: URLSearchParams): Promise<string> {
        const r = await this.http.text({ sourceId: this.id, url, method: form ? 'POST' : 'GET', body: form?.toString(), headers: form ? { 'Content-Type': 'application/x-www-form-urlencoded' } : undefined, responseType: 'text', credentials: 'omit', cache: { ttlMs: 300000, scope: 'public' } });
        if (r.status >= 400 || r.classification === 'challenge')
            throw new Error(`${this.name}: HTTP ${r.status}, ${r.classification}`);
        return r.body;
    }
    protected async json<T>(url: string): Promise<T> { return JSON.parse(await this.text(url)) as T; }
    protected dom(html: string) { return new DOMParser().parseFromString(html, 'text/html'); }
    protected absolute(url: string, base = this.website) { return new URL(url, base).href; }
    protected manga(url: string, title: string, coverUrl?: string): YomiriManga { return { id: url, url, sourceId: this.id, title, coverUrl, status: 'UNKNOWN', genres: [] }; }
    protected chapter(url: string, mangaId: string, name: string): YomiriChapter { return { id: url, url, mangaId, sourceId: this.id, name, chapterNumber: Number(name.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.') || 0), language: 'es' }; }
    protected pages(urls: string[], referer: string): YomiriPage[] { return urls.map((imageUrl, index) => ({ index, imageUrl: this.absolute(imageUrl, referer), sourceId: this.id, headers: { Referer: referer } })); }
    abstract getPopular(page?: number): Promise<{
        mangas: YomiriManga[];
        hasNextPage: boolean;
    }>;
    abstract search(query: string, page?: number): Promise<{
        mangas: YomiriManga[];
        hasNextPage: boolean;
    }>;
    abstract getManga(id: string): Promise<YomiriManga>;
    abstract getChapters(id: string): Promise<YomiriChapter[]>;
    abstract getPages(id: string): Promise<YomiriPage[]>;
}
